import React, { useEffect } from "react";
import { useJobConfigurationContext } from "../../../../contexts/JobConfigurationContext";
import ConfigurationDialogBase from "./ConfigurationDialogBase";
import NavigationStepper from "../NavigationStepper";
import GeneralConfigurationSection from "./Components/GeneralConfigurationSection";
import UserSection from "./Components/UserSection";

function QAConfigurationDialog({ selectedUsers }) {
  const {
    activeJob,
    currentScreen,
    setCurrentScreen,
    graduationConfidence,
    setGraduationConfidence,
    labellingSet,
    setLabellingSet,
    numberOfUsers,
    setNumberOfUsers,
    setSelectedUsers,
    pipelineJobName,
    setPipelineJobName,
    validateFields,
    saveJob,
    errors,
  } = useJobConfigurationContext();
  const handleSave = () => {
    if (validateFields()) {
      saveJob();
      setPipelineJobName("");
    }
  };

  useEffect(() => {
    if (currentScreen < 0)
    {
      setCurrentScreen(0);
    }
    if (currentScreen > 2 - 1)
    {
      setCurrentScreen(2 - 1);
    }
  }, [currentScreen])

  useEffect(() => {
      console.log("Updated selectedUsers:", selectedUsers);
      console.log("Updated activeJob:", activeJob);
  }, [selectedUsers, activeJob]); // ✅ Ensures it updates

  return (
    <ConfigurationDialogBase
      activeJob={activeJob}
      handleSave={handleSave}
      error={errors.general}
    >
      <NavigationStepper
        currentScreen={currentScreen}
        setCurrentScreen={setCurrentScreen}
        numScreens={2}
      />
      {currentScreen === 0 && (
        <GeneralConfigurationSection
          graduationConfidence={graduationConfidence}
          setGraduationConfidence={setGraduationConfidence}
          labellingSet={labellingSet}
          setLabellingSet={setLabellingSet}
          numberOfUsers={numberOfUsers}
          setNumberOfUsers={setNumberOfUsers}
          pipelineJobName={pipelineJobName}
          setPipelineJobName={setPipelineJobName}
        />
      )}
      {currentScreen === 1 && (
        <UserSection
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
        />
      )}
    </ConfigurationDialogBase>
  );
}

export default QAConfigurationDialog;
